import { render, staticRenderFns } from "./slot-wx-model.mpx?vue&type=template&id=25132e2d&isComponent&outputPath=components%2Fslot-wx-model2e17386d%2Findex"
import script from "./slot-wx-model.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslot-wx-model2e17386d%2Findex"
export * from "./slot-wx-model.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslot-wx-model2e17386d%2Findex"
import style0 from "./slot-wx-model.mpx?vue&type=style&index=0&id=25132e2d&prod&lang=stylus&mpxStyleOptions=%7B%22scoped%22%3Atrue%2C%22mid%22%3A%22_2e17386d%22%7D&isComponent&outputPath=components%2Fslot-wx-model2e17386d%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports